<template>
    <v-card class="elevation-12 px-0">
        <v-card-text class="px-6" id="scroller">
            <div>
                <p class="title primary--text mt-0 font-weight-bold">
                    Send to
                </p>
            </div>

            <v-sheet
                tile
                color="primary"
                class="pa-4 rounded-lg mb-5"
            >
                <v-row>
                    <v-col cols="8">
                        <p class="white--text subtitle-1 font-weight-bold my-0">
                            {{ recipient.name }}
                        </p>
                        <p class="white--text subtitle-2 my-0">
                            {{ recipient.email }}
                        </p>
                        <p class="white--text subtitle-2 my-0">
                            {{ recipient.country }}
                        </p>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            class="rounded-xl primary--text mt-4 px-6 text-none font-weight-bold"
                            color="white"
                            @click="$emit('edit')"
                        >
                            Edit
                        </v-btn>
                    </v-col>
                </v-row>
            </v-sheet>

            <div>
                <p class="title primary--text mt-0 font-weight-bold">
                    Invoice Details
                </p>
            </div>

            <v-sheet
                tile
                color="#f9f9f9"
                class="pa-4 rounded-lg"
            >
                <template v-if="items.length || showForm">
                    <div class="d-flex justify-space-between">
                        <p class="primary--text subtitle-1 font-weight-bold">
                            ITEMS
                        </p>
                        <p class="primary--text subtitle-1 font-weight-bold">
                            PRICE
                        </p>
                    </div>
                    <template v-for="(item, n) in items">
                        <div :key="n">
                            <item-form
                                v-if="!!selectedItem && n+1 === selectedItem.id"
                                :selectedItem="selectedItem"
                                :index="item.id"
                                @add="updateItem"
                                @cancel="selectedItem = null"
                            />
                            <invoice-item
                                v-else
                                :item="{ ...item, index: item.id }"
                                @edit="selectedItem = item"
                                @delete="deleteItem"
                            />
                            <hr
                                class="line my-3"
                                v-if="n+1 !== items.length"
                            />
                        </div>
                    </template>
                    <template v-if="showForm">
                        <hr
                            class="line my-3"
                            v-if="items.length"
                        />
                        <item-form
                            :key="itemKey"
                            :index="items.length+1"
                            @add="addItem"
                            @cancel="itemKey++; showForm = false"
                        />
                    </template>
                </template>
                <div class="text-center my-10" v-else>
                    <v-btn
                        class="rounded-xl primary--text my-0 px-6 text-none"
                        color="primary"
                        v-if="!showForm"
                        @click="showItemForm"
                        outlined
                    >
                        <v-icon>mdi-plus</v-icon>
                        Add Item
                    </v-btn>
                </div>
            </v-sheet>

            <div class="mt-5 text-center" v-if="items.length">
                <v-btn
                    class="rounded-xl primary--text my-0 px-6 text-none"
                    color="primary"
                    outlined
                    v-if="!showForm || !selectedItem"
                    @click="showItemForm"
                >
                    <v-icon>mdi-plus</v-icon>
                    Add Item
                </v-btn>
            </div>
        </v-card-text>
        <v-card-actions class="footer px-6">
            <div v-if="!showSelect">
                <p class="my-0 black--text subtitle-1 font-weight-bold">
                    INV-KA-17689
                </p>
                <div class="d-flex">
                    <p class="my-0 grey--text subtitle-2">
                        Due in {{ dueDays }} Days
                        <v-icon
                            small
                            class="pa-0 ml-n2"
                        >
                            mdi-chevron-right
                        </v-icon>
                    </p>
                    <v-btn
                        text
                        class="text-decoration-underline subtitle-2 pa-0 ma-0 ml-n2 text-none"
                        color="primary"
                        style="height: 20px"
                        @click="showSelect = true"
                    >
                        Change
                    </v-btn>
                </div>
            </div>
            <div v-else>
                <v-text-field
                    @blur="showSelect = false"
                    color="primary"
                    validate-on-blur
                    v-model="dueDays"
                    v-validate="'required'"
                    name="due"
                    class="py-0 my-0 select-box"
                    :error-messages="errors.first('due')"
                    hide-details
                    autofocus
                    style="width: 90px"
                    aria-required
                    required
                    single-line
                    min="1"
                    step="1"
                    type="number"
                    suffix="Days"
                />
            </div>
            <v-spacer />
            <v-btn
                class="rounded-xl white--text px-6 text-none"
                :class="{ 'grey--text': !items.length }"
                :color="items.length ? 'primary' : '#DCDCDF'"
                @click="preview"
            >
                Preview Invoice
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Vue from 'vue';
import InvoiceItem from '../components/invoice-item.vue';
import ItemForm from './item-form.vue';

export default {
    components: {
        InvoiceItem,
        ItemForm,
    },
    props: {
        recipient: Object,
        invoice: Object,
    },
    created() {
        const { dueDays, items } = this.invoice || {};
        if(dueDays) {
            this.dueDays = dueDays;
        }

        if(items) {
            this.items = items;
        }
    },
    data() {
        return {
            itemKey: 29,
            dueDays: 10,
            items: [],
            showForm: false,
            showSelect: false,
            selectedItem: null,
        }
    },
    methods: {
        showItemForm() {
            const scroller = document.getElementById("scroller");
            scroller.scrollTop = scroller.scrollHeight;
            this.showForm = true;
        },
        addItem(item) {
            this.items.push(item);
            this.showForm = false;
            this.itemKey += 1;
        },
        deleteItem(index) {
            this.items.splice(index-1, 1)
        },
        updateItem({ index, item }) {
            // this.items[index] = item;
            Vue.set(this.items, index, item);
            // this.$forceUpdate();
            this.selectedItem = null;
        },
        preview() {
            if(this.items.length) {
                this.$emit('proceed', {
                    dueDays: this.dueDays || 10,
                    items: this.items,
                })
            }
        },
    },
}
</script>

<style scoped>
#scroller {
    max-height: 70vh;
    overflow-y: auto;
}

.footer {
    box-shadow: 0px -2px 16px 4px rgba(0, 0, 0, 0.1);
}

.select-box >>> .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
    border-color: transparent !important;
}
</style>